import { useEffect } from 'react';
import Hero from '../components/home/Hero.js';
import AudienceSection from '../components/home/AudienceSection.js';
import HowItWorksSection from '../components/home/HowItWorksSection.js';
import PathwaysSection from '../components/home/PathwaysSection.js';
import PartnerSites from '../components/home/PartnerSites.js';
import HomeInviteSection from '../components/home/HomeInviteSection.js';
import Footer from '../components/home/Footer.js';
import ChatbotWidget from '../components/Chatbot/ChatbotWidget.js';
import DownloadAppModal from '../components/DownloadAppModal.js';
import useAuthStore from '../stores/authStore';
import { trackReferrer } from '../services/telegramTracker';
import './Home.css';

const Home = () => {
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    const referrer = document.referrer;
    const currentDomain = window.location.hostname;
    const isExternal = referrer && !referrer.includes(currentDomain);

    if (isExternal) {
      localStorage.setItem('last_external_referrer', referrer);
      localStorage.setItem('last_external_referrer_time', new Date().toISOString());
      trackReferrer(referrer, user?.username || null, 'external');
    } else if (!referrer) {
      const lastExternalReferrer = localStorage.getItem('last_external_referrer');
      const lastReferrerTime = localStorage.getItem('last_external_referrer_time');
      const hasTrackedDirect = sessionStorage.getItem('direct_visit_tracked');
      if (!hasTrackedDirect) {
        trackReferrer('direct', user?.username || null, 'direct', {
          lastExternalReferrer,
          lastReferrerTime,
        });
        sessionStorage.setItem('direct_visit_tracked', 'true');
      }
    }
  }, [user]);

  return (
    <div className="home">
      <DownloadAppModal />
      <Hero />
      <AudienceSection />
      <HowItWorksSection />
      <PathwaysSection />
      <div id="partners">
        <PartnerSites />
      </div>
      <HomeInviteSection />
      <Footer />
      <ChatbotWidget />
    </div>
  );
};

export default Home;
